<template>
  <div>
    <rxNavBar v-if="androidFlg == false" title="员工内部推荐" androidOrIOSFlag="true"></rxNavBar>
    <rxNavBar v-else title="员工内部推荐"></rxNavBar>
    <!--        搜索框/状态-->
    <div class="head">
      <div class="searchDiv">
        <div class="search">
          <input placeholder="姓名/手机号/证件号" v-model="searchValue" @keyup.enter="search">
        </div>
      </div>
      <!--            下拉-->
      <div class="downMenu" @click="showPicker = true">
        <div class="downMenuValue">{{ columns[number] ? columns[number].dictionaryTitle : '有效' }}</div>
        <div :class="showPicker ? 'uparrows' : 'arrows'"></div>
      </div>
      <van-popup v-model="showPicker" position="bottom">
        <van-picker show-toolbar :columns="columns" :default-index="number" value-key="dictionaryTitle" @cancel="showPicker = false"
                    @confirm="onConfirm"/>
      </van-popup>
    </div>
    <div class="blank-weight"></div>
    <div class="reviews">
      <van-pull-refresh v-model="refreshing"  @refresh="onRefresh" v-if="orders.length!=0">
        <van-list
            v-model="loading"
            :finished="finished"
            :finished-text="noContent ? '' : '已经到底了'"
            @load="onLoad"
        >
          <div class="review" v-for="(item,index) in orders" :key="index">
            <div :class="'top-title top-title-'+item.resumeStatus">
              {{ item.resumeStatusStr }}
            </div>
            <div class="vacationForm">
              <!-- <div class="vacationType"> <span>{{'推 荐 人:' + item.addStaffName }}</span></div> -->

              <div><span class="text">姓 名:</span><span class="content">{{ item.name }}</span></div>
              <div><span class="text">性 别:</span><span class="content">{{ item.gender_description}}</span></div>
              <div><span class="text">手 机 号:</span><span class="content">{{ item.phoneNum}}</span></div>
              <div><span class="text">推 荐 人:</span><span class="content">{{ item.addStaffName}}</span></div>

            </div>
            <div class="line"></div>

            <div class="bottom">
              <div class="check" v-if="checkAuthList(authButtonsList,'edit')&&(item.upDate=='Y')"
                   @click="saveDepartApply('edit',item)">修改
              </div>
              <div class="check" v-if="checkAuthList(authButtonsList,'cancel')&&(item.onProbation=='N')&&(item.resumeStatus=='0')"
                   @click="revoke(item)">
                   撤销
              </div>
              <div class="check" v-if="checkAuthList(authButtonsList,'onProbation')&&(item.onProbation=='Y')"
               @click="approve('trialJob',item)">试岗</div>
                <div class="look"
               @click="detail(item)">查看</div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
      <common-empty v-if="isEmptuyFlag"></common-empty>
      <div style="height: 70px"></div>
      <div class="sub_btn">
      <van-button  class="saveButton_Enable" size="large" v-if="checkAuthList(authButtonsList,'add')"
       @click="saveDepartApply('add')">添加
            </van-button>
      </div>
    </div>
    <van-popup
      class="van-popup--bottom"
      v-model="acceptedShow"
      position="bottom"
      :style="{ height: '260px' }"
    >
      <div class="popMaincontant">
        <div class="part-inputpart-row">
          <span class="otherExpenses-row-enablenon part-inputpart-row-header"
            >撤销原因</span
          >
          <!-- <span class="smallgraytext">(非必填)</span> -->
        </div>
        <van-field
          v-model="approvalOpinion"
          autosize
          type="textarea"
          class="mes_body"
          rows="4"
        />

      <div>
            <van-button  :class=" approvalOpinion == '' ? 'saveButton_Disable' : 'saveButton_Enable'" :disabled="approvalOpinion == ''" size="large" @click="revokeSave()">保存
            </van-button>
          </div>

      </div>
    </van-popup>
  </div>
</template>

<script>
import {checkAndroid, checkAuthList, checkIOS, getStaffId, responseUtil} from "../../../libs/rongxunUtil";
import {
  getStaffFuntionModelList,
  queryBaseData,
  getInterPolateResumePage,
  resumeApprovalRevoke
} from "../../../getData/getData";
import {
  Button,
  Dialog,
  Divider,
  DropdownItem,
  DropdownMenu,
  List,
  NavBar,
  Picker,
  Popup,
  PullRefresh,
  Search,
  Field
} from "vant";
import rxNavBar from "../../../components/rongxun/rx-navBar/navBar.vue";

export default {
  name: "staffEntry",
  components:{
    [Button.name]: Button,
    [Search.name]: Search,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Divider.name]: Divider,
    [NavBar.name]: NavBar,
    [List.name]: List,
    rxNavBar,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [PullRefresh.name]:PullRefresh,
    [Field.name]: Field,
  },
  data(){
    return{
      androidFlg:'',
      authButtonsList:[],
      refreshing: false,
      loading : true,
      finished: false,
      noContent:false,
      isEmptuyFlag: false,
      page:{currentPage:1,numberPage:10,},
      orders:[],
      count:0,
      //搜索/状态
      searchValue:'',
      showPicker:false,
      columns:[],
      number:0,
      revokeRemarks: '',
      acceptedShow: false,
      rowDataid: '',
      approvalOpinion: "",
    }
  },
  beforeRouteEnter(to, from, next) {
    //清除本地localStorage缓存
    if(from.name == null){
      localStorage.removeItem('currentLabel');
    }
    next()
  },
  created() {
    this.getStaffFuntionModelList()
    
  },
  mounted() {
    this.checkPhoneorMobel()
    this.initDicData()
    this.getStaffFuntionModelList()
    // this.finished = false;
    // this.loading = true;
    // this.refreshing = false
    // this.orders=[]
    // this.onLoad();
    this.finished = false;
    this.loading = true;
    this.refreshing = false
  },
  activated() {
    this.searchValue=''
    this.number = 0; 
    this.page.currentPage = 1;
    this.orders=[]
    this.getStaffFuntionModelList()
    this.onLoad();
  },
  methods:{
    revokeSave() {
      Dialog.confirm({
        title: "友情提示",
        message: "确定撤回吗？",
      }).then(() => {
        let that = this;
        console.log("that.rowData:",that.rowData);
        let initData = {};
        initData.staff_id = getStaffId();
        initData.id = that.rowData.tinId;
        initData.approval_id = that.rowData.approval_id;
        initData.approvalOpinion = that.approvalOpinion;
        resumeApprovalRevoke(initData).then((res) => {
          console.log(res.data);
          if (res.data.code == "0") {
            responseUtil.alertOK(that)
          } else {
            responseUtil.alertMsg(that, res.data.msg);
          }
            that.finished = false;
            that.orders = []
            that.page =  {currentPage:1,numberPage:10}
            that.loading = true;
            that.refreshing = false
            that.noContent = false
            that.acceptedShow =false
            that.onLoad();
        });
      });
    },
    saveDepartApply(type,val) {
      this.searchValue=''
        if(type == 'edit') {
            this.$router.push({
            name:'ecAddorEdit',
            query:{
              ...val
            }
          });

        } else {
            this.$router.push({
            name:'ecAddorEdit',
            query:{
            }
          });
        }
    },
    //下拉刷新
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      this.orders = []
      this.page =  {currentPage:1,numberPage:3}
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.refreshing = false
      this.noContent = false
      this.onLoad();
      responseUtil.alertMsg(this,"刷新成功")
    },
    search(){
      if(this.searchValue!=''){
        localStorage.setItem('searchValue',JSON.stringify(this.searchValue))
      }else{
        localStorage.removeItem('searchValue')
      }
      this.orders = [];
      this.page.currentPage = 1;
      this.finished = false
      this.loading = true
      this.noContent = false
      this.onLoad()
    },
    onConfirm(value, index){
      if(value){
        localStorage.setItem('currentLabel', JSON.stringify(index))
        this.number = index
      }
      this.orders = [];
      this.page.currentPage = 1;
      this.finished = false;
      this.showPicker = false
      this.loading = true;
      this.noContent = false
      this.onLoad()
    },
    onLoad() {
      let that = this
      let queryData = {
        currentPage: that.page.currentPage,
        numberPage: that.page.numberPage,
        staff_id: getStaffId(),
        resumeStatus: this.number,
        searchValue: this.searchValue,
      }
      
      getInterPolateResumePage(queryData).then(function (response) {
        responseUtil.dealResponse(that, response, () => {
          that.count = response.data.data.pageCount
          let list=response.data.data.data?response.data.data.data:[]
          for (let i = 0; i < list.length; i++) {
            that.orders.push(list[i])
          }
          console.log("that.orders")
          console.log(that.orders)
          if(that.refreshing){
            that.refreshing = false
          }
          // 加载状态结束
          that.loading = false;
          that.page.currentPage++;
          // 数据全部加载完成
          if (that.orders.length >= that.count) {
            that.finished = true;
          }
          // 判断数据是否为空，空则显示空状态图
          if (that.orders.length == 0) {
            that.isEmptuyFlag = true;
          } else {
            that.isEmptuyFlag = false;
          }

          if (1 == that.page.currentPage && (!list || 0 == list.length)) {
            that.noContent = true
          } else {
            that.noContent = false
          }
        })
      })
    },

    approve(enterType,value){
      this.searchValue=''
      value.flag = enterType
      this.$router.push({
        name:'ecTrialjob',
        query:{
          ...value
        }
      });
    },
    revoke(item){
      // this.revokeRemarks = ''
      // this.rowDataid = item.id
      // this.acceptedShow = true

      this.approvalOpinion = "";
      this.rowData = item;
      this.acceptedShow = true;
      
    },
    detail(value){
      value["enterType"] = "detail"
      this.$router.push({
        name:'ecAddorDetail',
        query:{
          ...value
        }
      });
    },



    checkPhoneorMobel() {
      if(checkAndroid()) {
        this.androidFlg = true
      }
      else if(checkIOS()) {
        this.androidFlg = false
      }
    },
    getStaffFuntionModelList () {
      var that = this
      let data = {}
      data.staff_id = getStaffId()
      data.menuName = 'ecommendation'
      getStaffFuntionModelList(data).then(function (response) {
        responseUtil.dealResponse(that, response, () => {
          that.authButtonsList = response.data.data.data
          console.log(that.authButtonsList,"that.authButtonsList=====")
        })
      })
    },
    checkAuthList,
    //初始化字典数据
    initDicData: function () {
      const that = this
      let initData = {}
      initData.fdName = [ 'RESUMESTATUSMAP']
      queryBaseData(initData).then(function (response) {
        responseUtil.dealResponse(that, response, () => {
          let list = response.data.data.RESUMESTATUSMAP
          for (let i = 0; i < list.length; i++) {
            that.columns.push(list[i])
          }
        })
      })
    },
  }
}
</script>

<style scoped lang="less">
*{
  padding: 0;
  margin: 0;
}

//搜索+选择
.head {
  width: 100%;
  position: fixed;
  z-index: 8;
  overflow: hidden;
  background: #f8f8f8;
  //搜索框
  .searchDiv {
    width: 100%;
    height: 40px;

    .search {
      width: 90%;
      height: 40px;
      margin: 10px auto;
      border-radius: 20px;
      background-color: #eeeeee;
      display: flex;

      input {
        width: 80%;
        background-color: #eeeeee;
        border: none;
        font-size: 15px;
      }
    }

    .search:before {
      content: '';
      display: block;
      background: url("../../../assets/images/search.png") no-repeat center center;
      background-size: 50% 50%;
      width: 40px;
      height: 40px;
    }

    input::placeholder {
      font-size: 15px;
    }
  }
  //下拉框
  .downMenu {
    height: 28px;
    width: 20%;
    margin: 15px 15px 0;
    line-height: 40px;
    display: flex;
    align-items: center;
    .downMenuValue {
      /*width: 14%;*/
      font-size: 14px;
      color: #FF5D3B;
    }

    .arrows {
      height: 0;
      width: 0;
      border: 3px solid;
      border-color: black transparent transparent transparent;
      margin-top: 1px;
      margin-left: 8px;
    }

    .uparrows {
      height: 0;
      width: 0;
      border: 3px solid;
      border-color: transparent transparent black transparent;
      margin-bottom: 6px;
      margin-left: 8px;
    }
  }
}

.blank-weight {
  height: 93px;
}
//列表
.reviews {
  overflow: hidden;
  position: relative;
}
.review {
  margin: 0 15px 15px 15px;
  height: auto;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
}

.top-title{
  margin: 0;
  width: fit-content;
  padding: 0 5px;
  height: 20px;
  font-size: 10px;
  text-align: center;
  line-height: 22px;
  border-radius: 8px 0;
  color: white;
}

.top-title-0,.top-title-1,.top-title-2,.top-title-3{
  background: linear-gradient(to right, #63cb96, #30d0ac);
}
.top-title-1,.top-title-2{
  background: linear-gradient(to right, #bfcbd9, #a8b9cc);
}
.top-title-3,.top-title-4{
  background: linear-gradient(to right, #ffbe72, #ff6c41);
}
.top-title-5{
  background: linear-gradient(to right, #cc004b, #660026);
}
.top-title-6{
  background: linear-gradient(to right,  #7cc7ff, #3596fd);
}

/*入职表*/
.vacationForm {
  /*height: 168px;*/
  width: 315px;
  margin-left: 15px;
  margin-bottom: 15px;
  /*line-height: 30px;*/
}

.vacationForm div {
  line-height: 20px;
}

/*标题*/
.vacationType {
  color: #ff5809;
  font-size: 14px;
  font-weight: bold;
  margin-top: 8px;
}

/*时间*/
.start_endTime {
  color: #ff5809;
  font-size: 14px;
  font-weight: bold;
  margin-top: 6px;
}
/*行信息标题label*/
.text {
  font-weight: bold;
  font-size: 14px;
  margin-right: 0.2rem;
  /*letter-spacing: 1px;*/
}
/*行信息内容*/
.content {
  font-size: 13px;
  color: #9a9a9a;
}
.line {
  width: 100%;
  border-bottom: 1px solid #D8D8D8;
}
/*    下部按钮*/
.bottom{
  display: flex;
  justify-content: right;
  align-items: center;
  margin: 0.3rem 0;
}

.check,.look{
  /*float: right;*/
  //margin-top: 0.2rem;
  margin-right: 0.5rem;
  height: 0.82rem;
  width: 2.3rem;
  border-radius: 0.2rem;
  border: 0rem solid transparent;
  box-shadow: none;
  line-height: 0.7rem;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
}
/*按钮*/
.check{
  background: -webkit-linear-gradient(left,#FFC274,#FF5D3B);
  color: white;
}
.look{
  padding: 0.01rem;
  border: 0.03rem solid transparent;
  background-image: linear-gradient(white,white),
  linear-gradient(to right ,#FFC274,#FF5D3B);
  background-clip: padding-box,border-box;
  background-origin: border-box;
  color: #FF5D3B;
}
.saveButton_Enable{
  background: linear-gradient(to right, #fdc07f 0px, #f86513 100%) repeat scroll 0% 0%;
  color: white;
  width: 345px;
  height: 50px;
  border-radius: 8px;
  font-size: 18px;
  line-height: 1.22rem;
  text-align: center;
//   margin: 0.1rem 0 0.3rem;

}
.sub_btn {
//   margin: 0.8rem auto 0.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
//   flex-direction: column;
  position: fixed;
  bottom: 0px;
  width: 100%;
  height: 70px;
  background: #fff;
}
.part-inputpart-row {
        display: flex;
        flex-direction: row;
        border-radius: 8px;
        align-items: center;
        height: 45px;
        // background-color: #ffffff;
        margin-top: 15px;
    }
    .otherExpenses-row-enablenon{
        margin-left: 10px;
    }
    .part-inputpart-row-header {
        font-weight: 900;
        font-size: 15px;
        white-space: nowrap;
    }
    .smallgraytext{
        color: #D8D8D8;
        font-size: 12px;
        margin-bottom: -3px;
    }
    .cancelOrderPopupTextValue{
        margin-bottom: 20px;
    }
    .part-button {
        height: 45px;
        border-radius: 10px;
        // background-color: #ededed;
        color: #ffffff;
        text-align: center;
        line-height: 45px;
        font-size: 15px;
        font-weight: 900;
        margin-top: 20px;
    }
    .part-button-enabled {
        background-image: linear-gradient(to right, #ffc274, #ff5d3b);
    }
    .van-popup--bottom {
      /*z-index: 2004;*/
      background-color: #f8f8f8;
    }
    .mes_body {
        border-radius: 10px;
        background-color: #ffff;
        margin-bottom: 20px;
      }
      .popMaincontant {
        width: 92%;
        margin: 0 auto;

      }
</style>